import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type FieldValueInfo_DateFieldValue_Fragment = { __typename?: 'DateFieldValue', date?: string | null };

export type FieldValueInfo_DerivedFieldValue_Fragment = { __typename?: 'DerivedFieldValue' };

export type FieldValueInfo_JsonFieldValue_Fragment = { __typename?: 'JsonFieldValue' };

export type FieldValueInfo_LinkFieldValue_Fragment = { __typename?: 'LinkFieldValue' };

export type FieldValueInfo_LongTextFieldValue_Fragment = { __typename?: 'LongTextFieldValue', longText?: string | null };

export type FieldValueInfo_NumberFieldValue_Fragment = { __typename?: 'NumberFieldValue', number?: number | null };

export type FieldValueInfo_RatingFieldValue_Fragment = { __typename?: 'RatingFieldValue', rating?: number | null };

export type FieldValueInfo_SelectFieldValue_Fragment = { __typename?: 'SelectFieldValue', selectedOptions?: Array<string> | null };

export type FieldValueInfo_SelectMultiFieldValue_Fragment = { __typename?: 'SelectMultiFieldValue', multiSelectedOptions?: Array<string> | null };

export type FieldValueInfo_TextFieldValue_Fragment = { __typename?: 'TextFieldValue', text?: string | null };

export type FieldValueInfo_ToggleFieldValue_Fragment = { __typename?: 'ToggleFieldValue', toggle?: boolean | null };

export type FieldValueInfo_UrlFieldValue_Fragment = { __typename?: 'UrlFieldValue' };

export type FieldValueInfo_UserMultiFieldValue_Fragment = { __typename?: 'UserMultiFieldValue', multiSelectedMembers?: Array<{ __typename?: 'AccountUserGroupSelectMemberValue', emoji?: string | null, displayName?: string | null, id: string } | { __typename?: 'UserSelectMemberValue', color?: string | null, displayImageUrl?: string | null, displayName?: string | null, id: string } | null> | null };

export type FieldValueInfo_UserSingleFieldValue_Fragment = { __typename?: 'UserSingleFieldValue', singleSelectedMember?: Array<{ __typename?: 'AccountUserGroupSelectMemberValue', emoji?: string | null, displayName?: string | null, id: string } | { __typename?: 'UserSelectMemberValue', color?: string | null, displayImageUrl?: string | null, displayName?: string | null, id: string } | null> | null };

export type FieldValueInfo_UsersFieldValue_Fragment = { __typename?: 'UsersFieldValue', selectedMembers?: Array<{ __typename?: 'AccountUserGroupSelectMemberValue', emoji?: string | null, displayName?: string | null, id: string } | { __typename?: 'UserSelectMemberValue', avatarColor?: Types.AvatarColor | null, color?: string | null, displayImageUrl?: string | null, displayName?: string | null, id: string } | null> | null };

export type FieldValueInfoFragment = FieldValueInfo_DateFieldValue_Fragment | FieldValueInfo_DerivedFieldValue_Fragment | FieldValueInfo_JsonFieldValue_Fragment | FieldValueInfo_LinkFieldValue_Fragment | FieldValueInfo_LongTextFieldValue_Fragment | FieldValueInfo_NumberFieldValue_Fragment | FieldValueInfo_RatingFieldValue_Fragment | FieldValueInfo_SelectFieldValue_Fragment | FieldValueInfo_SelectMultiFieldValue_Fragment | FieldValueInfo_TextFieldValue_Fragment | FieldValueInfo_ToggleFieldValue_Fragment | FieldValueInfo_UrlFieldValue_Fragment | FieldValueInfo_UserMultiFieldValue_Fragment | FieldValueInfo_UserSingleFieldValue_Fragment | FieldValueInfo_UsersFieldValue_Fragment;

export const FieldValueInfo = /*#__PURE__*/ gql`
    fragment FieldValueInfo on FieldValue {
  ... on LongTextFieldValue {
    longText
  }
  ... on NumberFieldValue {
    number
  }
  ... on RatingFieldValue {
    rating
  }
  ... on SelectFieldValue {
    selectedOptions
  }
  ... on SelectMultiFieldValue {
    multiSelectedOptions
  }
  ... on TextFieldValue {
    text
  }
  ... on ToggleFieldValue {
    toggle
  }
  ... on DateFieldValue {
    date
  }
  ... on UsersFieldValue {
    selectedMembers {
      displayName
      id
      ... on UserSelectMemberValue {
        avatarColor
        color
        displayImageUrl
      }
      ... on AccountUserGroupSelectMemberValue {
        emoji
      }
    }
  }
  ... on UserSingleFieldValue {
    singleSelectedMember {
      displayName
      id
      ... on UserSelectMemberValue {
        color
        displayImageUrl
      }
      ... on AccountUserGroupSelectMemberValue {
        emoji
      }
    }
  }
  ... on UserMultiFieldValue {
    multiSelectedMembers {
      displayName
      id
      ... on UserSelectMemberValue {
        color
        displayImageUrl
      }
      ... on AccountUserGroupSelectMemberValue {
        emoji
      }
    }
  }
}
    ` as unknown as DocumentNode<FieldValueInfoFragment, unknown>;

        

        
export const useFieldValueInfoFragment = (
  input: string | Omit<UseFragmentOptions<FieldValueInfoFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'FieldValue' } };
    return input;
  })();

  return useFragment<FieldValueInfoFragment>({
    fragment: FieldValueInfo,
    fragmentName: 'FieldValueInfo',
    ...options,
  });
};
  
        